'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BgLineStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var style = function style(_ref) {
  var themeFromProvider = _ref.theme,
      customThickness = _ref.customThickness;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var strokeSize = theme.reactackle.components.progress.circle.strokeSize;
  var colourDefault = theme.reactackle.components.progress.circle.bgLine.colourDefault;
  return (0, _styledComponents.css)(['stroke:', ';stroke-width:', ';'], colourDefault, (0, _reactackleCore.getValueString)(customThickness || strokeSize));
};

var BgLineStyled = exports.BgLineStyled = _styledComponents2.default.circle.withConfig({
  displayName: 'BgLineStyled'
})(['fill:none;stroke-dasharray:0 158;transform-origin:center;', ''], style);

BgLineStyled.displayName = 'BgLineStyled';